export default __webpack_public_path__ + "static/media/expl-dissect_12_DE.92e22fd6.png";